











import Vue from 'vue'
import Component from 'vue-class-component'
// store
import moduleStore from './store/VipWechatPay'
// component
import { Toast, Dialog } from 'vant'

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class ycdWechatPaySuccess extends Vue {

  mounted() {
    // 延迟 1s 查询支付结果
    setTimeout(() => {
      const orderId = (this.$route.query.orderId || '') as string
      this.getYcdPaymentStatus(Number(orderId), 1)
    }, 1000)
  }

  /** 获取支付状态 */
  getYcdPaymentStatus(orderId: number, count: number) {

    console.log('getYcdPayStatusInfo', orderId)

    this.$http('getYcdPayStatusInfo', { orderId })
      .then(res => {
        const { code, data } = res
        if (code === 200) {
          switch(data.status) {
            case '支付成功':
              // 成功确认弹窗
              Dialog.confirm({
                title: '支付成功',
                message: '订单支付成功，前往小程序体验',
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                className: "confirm-dialog",
              })
                .then(() => {
                  this.toYcdWechat()
                })
              break
            case '已创建':
              if (count < 20) {
                // 继续轮询
                setTimeout(() => {
                  this.getYcdPaymentStatus(orderId, count + 1)
                }, 3000)
              }
              break
          }
        }
      })
  }

  buyAgain() {
    this.$router.push({
      path: '/ycd-vip'
    })
  }

  toYcdWechat() {
    window.location.href = '/toYcdWechat.html'
  }

}
